import React, {Component} from 'react';
import {Line} from 'rc-progress';
import './progress-bar.scss';

class ProgressBar extends Component{

    constructor(props){
        super(props)
        // console.log('bring on the progress bar props: ', this.props)
    }


    render(){

        return(
            <div id="progress-bar__container">
                <Line strokeWidth="2" percent={this.props.percentage} strokeColor="#e7be04" strokeLinecap="butt"/>
            </div>
        )
    }


}

export default ProgressBar;